var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-wrapper"},[(_vm.$store.state.user == null)?_c('admin-auth'):_c('div',[_c('admin-nav'),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }